import { useEffect } from 'react';
import { store } from '../redux/configureStore';

/**
 * Хук для инициализации синхронизации серверного времени
 * Запускается при монтировании компонента и настраивает периодическую синхронизацию
 */
const useTimeSync = () => {
  useEffect(() => {
    const { getServerTime } = require('../redux/reducers/utils/commonReducer');
    
    // Запрашиваем серверное время при инициализации
    const initSync = async () => {
      try {
        await store.dispatch(getServerTime());
        console.log('Server time synchronization initialized');
      } catch (error) {
        console.error('Failed to initialize server time sync:', error);
      }
    };
    
    initSync();
    
    // Периодически синхронизируем время каждую минуту
    const intervalId = setInterval(() => {
      store.dispatch(getServerTime());
    }, 1 * 60 * 1000); // 1 минута для более частой синхронизации
    
    // КРИТИЧЕСКИ ВАЖНО: очищаем интервал при размонтировании
    return () => {
      clearInterval(intervalId);
      console.log('Server time synchronization cleared');
    };
  }, []); // Пустой массив зависимостей - выполняется только один раз
};

export default useTimeSync;
